import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';
import { provideNativeDateAdapter } from '@angular/material/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { provideEchartsCore } from 'ngx-echarts';
import * as echarts from 'echarts';
import { ErrorHandler } from '@angular/core';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './shell-global/auth/auth.interceptor';

import { loadingInterceptor } from './shell-global/loading/loading.interceptor';
// import { GlobalErrorHandlerService } from './shell-global/shared/global-error-handler.service';



export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(
      withInterceptors([loadingInterceptor,authInterceptor])   // ← loading first
    ),
    provideEchartsCore({ echarts }),
    provideAnimations(),
    provideToastr(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideNativeDateAdapter(),
    //   {
    //   provide: ErrorHandler,
    //   useClass: GlobalErrorHandlerService
    // },
    provideRouter(
      routes,
      withRouterConfig({
        onSameUrlNavigation: 'reload'
      })
    )
  ]
};